export default {
  account: {
    academy_capitalized: "학원",
    change_photo: "사진 변경",
    currency: "통화",
    currency_description: "학생 수업료 및 교사 급여를 위한 통화.",
    email_capitalized: "이메일",
    first_name_capitalized: "이름",
    language: "언어",
    language_settings: "언어 설정",
    last_name_capitalized: "성",
    personal_information: "개인 정보",
    plan_usage: "계획 및 사용",
    policy: "정책",
    policy_setting_before: "몇 시간 전",
    policy_setting_cancel: "취소",
    policy_setting_cancel_subtitle: "수업 취소 요청을 몇 시간 전에 할 수 있는지 설정하십시오.",
    policy_subtitle: "수업 일정 변경 요청을 몇 시간 전에 할 수 있는지 설정하십시오.",
    profile: "프로필",
    reschedule: "일정 변경",
    subscription: "구독",
    subscription_info_contact: "{'구독을 관리하거나 취소하려면 yan@getfunclass.com으로 연락하십시오. 감사합니다!'}",
    subtitle: "여기에서 계정 설정을 관리할 수 있습니다.",
    title: "계정 설정"
  },
  auth: {
    agency_name: "수업 센터",
    agree_to: "동의합니다",
    alreadyhasaccount: "이미 계정이 있습니까?",
    confirmPassword: "비밀번호 확인",
    createaccount: "계정 만들기",
    email: "이메일",
    email_enter: "이메일을 입력하세요",
    email_send: "이메일 보내기",
    firstname: "이름",
    firstname_student: "학생 이름",
    forgotpassword: "비밀번호를 잊으셨나요?",
    hasaccount: "계정이 없으신가요?",
    lastname: "성",
    login: "로그인",
    loginbutton: "로그인",
    logout: "로그아웃",
    no_active_account: "입력한 자격 증명으로 활성 계정을 찾을 수 없습니다",
    password: "비밀번호",
    passwordreset: "비밀번호 재설정",
    passwordresetbutton: "비밀번호 재설정",
    required: {
      agency_name: "수업 센터 이름은 필수 항목입니다",
      email: "이메일은 필수 항목입니다",
      email_exists: "이 이메일로 이미 계정이 존재합니다",
      first_name: "이름은 필수 항목입니다",
      invalid_email: "이메일이 잘못되었습니다",
      last_name: "성은 필수 항목입니다",
      password: "비밀번호는 필수 항목입니다",
      password_length: "비밀번호는 최소 8자 이상이어야 합니다",
      password_requirement: "비밀번호는 대문자와 소문자, 숫자 및 특수 문자({'@'} $ ! % * ? & #)를 포함해야 합니다."
    },
    reset: "재설정",
    signup: "가입하기",
    signup_subtitle: "Funclass에서 계정을 만들기 위해 자격 증명을 입력하세요.",
    terms: "이용 약관"
  },
  button: {
    archive: "보관",
    copy: "복사!",
    delete: "삭제",
    edit: "편집",
    invite: "초대",
    save: "저장",
    submit: "제출",
    unarchive: "보관 취소"
  },
  course: {
    chinese_students: "이 수업에는 중국에 있는 학생들이 있습니다",
    class_name: "수업 이름",
    class_name_placeholder: "여기에 수업 이름을 입력하세요",
    class_settings: {
      account_type: "계정 유형",
      account_type_warning_non_gamified: "학생들은 애완동물을 가지지 않으며 XP/HP를 획득하지 않습니다.",
      account_type_warning_setup: "게임화 유형은 수업 생성 시 한 번만 설정할 수 있습니다.",
      enable_breakout_room: "브레이크아웃 룸 활성화",
      gamified: "게임화된",
      non_gamified: "비게임화된",
      recording_exclude_webcam: "녹화에는 학생들의 웹캠이 포함되지 않습니다",
      title: "교실 설정"
    },
    create: "수업 추가",
    delete: "삭제",
    delete_confirmation: "삭제 확인",
    delete_message: "이 수업을 삭제하시겠습니까?",
    delete_student: "이 학생을 수업에서 제거하시겠습니까?",
    duration: "지속 시간",
    duration_time_unit: "분",
    edit: "수업 편집",
    filters: {
      active: "활성 수업",
      all: "모든 수업",
      archived: "보관된 수업"
    },
    join: "수업 참여",
    link_valid_for: "이 링크는 {n}일 동안 유효합니다.",
    name_too_short: "과정 이름은 최소 2자 이상이어야 합니다",
    no_content: {
      filtered: {
        subtitle: "필터를 변경해 보세요.",
        title: "여기에 수업이 없습니다"
      },
      general: {
        teacher_subtitle: "“수업 추가” 버튼을 클릭하여 시작하세요!",
        teacher_subtitle_agency: "아직 배정된 과정이 없습니다. 학원이 과정을 배정할 때까지 기다려주세요.",
        title: "아직 생성된 수업이 없습니다"
      }
    },
    notify: {
      archive_course_error: "수업 보관 중 오류",
      archive_course_success: "{courseName} 수업이 성공적으로 보관되었습니다!",
      copy_link_error: "링크 복사 중 오류",
      copy_link_success: "복사됨!",
      delete_course_error: "수업 삭제 중 오류",
      edit_course_error: "수업 편집 중 오류",
      required_fields: "필수 필드를 채워주세요",
      start_meeting_error: "회의 시작 오류. 다시 시도해 주세요.",
      unarchive_course_error: "수업 보관 취소 중 오류",
      unarchive_course_success: "{courseName} 수업이 성공적으로 보관 취소되었습니다!"
    },
    please_resubscribe: "계속하려면 Funclass에 다시 구독해 주세요.",
    progress: "진행 상황",
    resubscribe: "다시 구독",
    share: "수업 공유",
    shareText: "학생들이 수업에 참여할 수 있도록 링크를 공유하세요!",
    start: "수업 시작",
    subscription_expired: "구독 만료",
    title: "수업 대시보드",
    view: "수업 보기"
  },
  datetime: {
    days: {
      friday: "금요일",
      initials: {
        friday: "금",
        monday: "월",
        saturday: "토",
        sunday: "일",
        thursday: "목",
        tuesday: "화",
        wednesday: "수"
      },
      monday: "월요일",
      saturday: "토요일",
      short: {
        friday: "금요일",
        monday: "월요일",
        saturday: "토요일",
        sunday: "일요일",
        thursday: "목요일",
        tuesday: "화요일",
        wednesday: "수요일"
      },
      sunday: "일요일",
      thursday: "목요일",
      tuesday: "화요일",
      wednesday: "수요일"
    },
    time_format: "{time}에",
    today: "오늘",
    tomorrow: "내일",
    yesterday: "어제"
  },
  homework: {
    assign: {
      assignment_info: {
        attach_files: "파일 첨부",
        attachments: "첨부파일",
        choose_class: "할당할 수업을 선택하세요",
        class: "수업",
        description: "과제 설명",
        due_date: "마감일 (당신의 로컬 시간)",
        due_date_past: "마감일은 미래여야 합니다",
        submission_required: "제출이 필요합니다",
        title: "제목",
        title_required: "제목은 필수 항목입니다"
      },
      confirm_leave: "이 페이지를 떠나시겠습니까? 변경 사항이 저장되지 않습니다.",
      create: "할당",
      remove_attachment: "제거",
      title: "과제 할당",
      upload_attachments: "첨부 파일 업로드"
    },
    dashboard: {
      archived: "보관됨",
      create: "과제 할당",
      delete_button: "{assignment} 삭제",
      delete_confirmation: "삭제 확인",
      delete_message: "이 과제를 삭제하시겠습니까?",
      due: "마감일",
      filters: {
        all_classes: "모든 수업",
        all_graded: "모두 채점됨",
        any_status: "모든 상태",
        archived: "보관됨",
        assigned: "할당됨",
        no_submission_needed: "제출이 필요 없음",
        to_be_graded: "채점 대기 중"
      },
      graded_on: "채점 일자",
      header: {
        class: "수업",
        due: "마감일",
        status: "상태",
        title: "제목"
      },
      na: "해당 없음",
      no_content: {
        completed: {
          subtitle: "채점 대기 중인 완료된 과제가 여기에 표시됩니다.",
          title: "완료된 과제가 없습니다."
        },
        filtered: {
          subtitle: "찾고 있는 과제를 찾으려면 필터를 변경해 보세요.",
          title: "필터와 일치하는 과제가 없습니다."
        },
        general: {
          subtitle: "과제 할당 버튼을 클릭하여 시작하세요!",
          title: "생성된 과제가 없습니다."
        },
        graded: {
          subtitle: "채점된 과제가 여기에 표시됩니다.",
          title: "채점된 과제가 없습니다."
        },
        pending: {
          subtitle: "새로운 과제를 확인하려면 나중에 다시 방문하세요.",
          title: "보류 중인 과제가 없습니다."
        }
      },
      no_due_date: "마감일 없음",
      notify: {
        archive_assignment_error: "과제 보관에 실패했습니다. 나중에 다시 시도해 주세요.",
        archive_assignment_success: "과제가 성공적으로 보관되었습니다!",
        delete_assignment_error: "과제 삭제에 실패했습니다. 나중에 다시 시도해 주세요.",
        delete_assignment_success: "과제가 성공적으로 삭제되었습니다!",
        unarchive_assignment_error: "과제 보관 취소에 실패했습니다. 나중에 다시 시도해 주세요.",
        unarchive_assignment_success: "과제가 성공적으로 보관 취소되었습니다!"
      },
      num_submitted: "{submitted} / {total} 제출됨",
      submission_not_required: "제출이 필요 없음",
      submit: "제출",
      submitted_on: "제출 일자",
      tabs: {
        completed: "완료됨",
        graded: "채점 완료",
        pending: "보류 중"
      },
      title: "과제 대시보드",
      view_submission: "보기"
    },
    details: {
      attach_files: "파일 첨부",
      attachments: "첨부파일",
      delete_button: "{assignment} 삭제",
      delete_confirmation: "삭제 확인",
      delete_message: "이 과제를 삭제하시겠습니까?",
      description: "설명",
      download_attachment: "다운로드",
      due: "마감일",
      edit_homework: "과제 수정",
      edit_submission: "제출 수정",
      graded_on: "채점 일자",
      homework_details: "과제 상세 정보",
      homework_submission: "과제 제출",
      not_submitted: "미제출",
      post_submission_success: "제출이 성공적으로 전송되었습니다!",
      remove_attachment: "제거",
      reward: "보상:",
      student_submissions: "학생 제출",
      submission_not_required: "제출이 필요 없음",
      submit_homework: "제출",
      submitted_on: "제출 일자",
      teacher_feedback: "교사 피드백",
      title: "과제",
      upload_attachments: "첨부 파일 업로드",
      view_submission: "보기",
      your_submission: "당신의 제출물"
    },
    edit: {
      assignment_info: {
        attach_files: "파일 첨부",
        attachments: "첨부파일",
        choose_class: "할당할 수업을 선택하세요",
        class: "수업",
        description: "과제 설명",
        due_date: "마감일 (당신의 로컬 시간)",
        due_date_past: "마감일은 미래여야 합니다",
        submission_required: "제출이 필요합니다",
        title: "제목",
        title_required: "제목은 필수 항목입니다"
      },
      confirm_leave: "이 페이지를 떠나시겠습니까? 변경 사항이 저장되지 않습니다.",
      keep_attachment: "유지",
      remove_attachment: "제거",
      save_changes: "변경 사항 저장",
      title: "과제 수정",
      upload_attachments: "첨부 파일 업로드"
    },
    edit_submission: {
      attach_files: "파일 첨부",
      attachments: "첨부파일",
      description: "설명",
      download_attachment: "다운로드",
      due: "마감일",
      edit_submission_success: "제출 수정이 성공적으로 완료되었습니다!",
      homework_details: "과제 상세 정보",
      keep_attachment: "유지",
      last_submitted_on: "마지막 제출일:",
      remove_attachment: "제거",
      resubmit_homework: "다시 제출",
      title: "제출 수정",
      upload_attachments: "첨부 파일 업로드",
      your_submission: "당신의 제출물"
    },
    submission_details: {
      attach_files: "파일 첨부",
      attachments: "첨부파일",
      description: "과제 제출",
      download_attachment: "다운로드",
      graded_on: "채점 일자",
      remove_attachment: "제거",
      reward: "보상:",
      reward_xp: "보상 XP",
      reward_xp_placeholder: "XP 금액을 입력하세요",
      rewarding: "보상 중",
      save_reward: "저장",
      save_reward_success: "보상 금액이 성공적으로 저장되었습니다!",
      send_feedback: "전송",
      send_feedback_success: "피드백이 성공적으로 전송되었습니다!",
      submitted_on: "제출 일자",
      teacher_feedback: "교사 피드백",
      title: "과제",
      your_feedback: "당신의 피드백"
    }
  },
  inclass: {
    endLesson: "수업을 종료하시겠습니까?"
  },
  inclassQuiz: {
    dragMe: "나를 드래그하세요",
    folderTitle: "폴더 선택",
    modeTitle: "모드 선택",
    noQuizYet1: "여기에는 퀴즈가 없습니다.",
    noQuizYet2: "수업 외부에서 먼저 퀴즈를 생성하세요.",
    quizRuleDescription1: "• 학생들이 문제를 맞히면 몬스터가 생명을 잃습니다",
    quizRuleDescription2: "• 학생들이 문제를 틀리면 생명을 잃습니다",
    quizRuleDescription3: "• 퀴즈가 끝날 때, 학생들이 몬스터보다 더 많은 생명을 가져야 배틀에서 이길 수 있습니다!",
    quizRuleDescriptionStudent1: "• 문제를 맞히면 몬스터가 생명을 잃습니다",
    quizRuleDescriptionStudent2: "• 문제를 틀리면 생명을 잃습니다",
    quizRuleDescriptionStudent3: "• 퀴즈가 끝날 때, 당신이 몬스터보다 더 많은 생명을 가져야 배틀에서 이길 수 있습니다!",
    studentsJoinedCount: "학생들이 참여했습니다",
    teacherPreStartQuiz: "퀴즈를 시작하려고 합니다...",
    title: "퀴즈 선택"
  },
  lesson_status: {
    cancelled: "취소됨",
    completed: "완료됨",
    completed_absence: "완료됨 (결석)",
    no_show: "노쇼",
    ongoing: "진행 중",
    rescheduled: "재조정됨",
    scheduled: "예약됨",
    started: "시작됨"
  },
  meeting: {
    attention_tracker_disable: "주의 추적기 비활성화",
    attention_tracker_enable: "주의 추적기 활성화",
    button_join_quiz: "활성 퀴즈 참여"
  },
  misc: {
    handbook: "핸드북"
  },
  my_calendar: {
    abort: "중지",
    accept_request: "요청 승인",
    all_members: "모든 회원",
    attendees: "참석자",
    cancel: "취소",
    cancel_lesson: "수업 취소",
    cancel_lesson_title: "수업 취소",
    cancellation_constraint: "모든 취소는 최소 {hours} 시간 전에 완료되어야 합니다",
    confirm: "확인",
    confirm_approve_reschedule: "이 일정 변경 요청을 승인하시겠습니까?",
    course: "강좌",
    date: "날짜",
    date_time: "날짜 및 시간",
    day: "일",
    from: "부터",
    from_admin: "관리자",
    join: "참여",
    month: "월",
    next: "다음",
    notes: "메모",
    notify: {
      approve_reschedule_request_error: "일정 변경 요청 승인이 실패했습니다. 다시 시도해 주세요.",
      approve_reschedule_request_success: "일정 변경 요청이 성공적으로 승인되었습니다.",
      request_cancel_error: "수업 취소 요청 제출에 실패했습니다. 다시 시도해 주세요.",
      request_cancel_success: "수업 취소 요청이 성공적으로 제출되었습니다.",
      request_reschedule_error: "수업 일정 변경 요청에 실패했습니다. 다시 시도해 주세요.",
      request_reschedule_success: "수업 일정 변경 요청이 성공적으로 제출되었습니다."
    },
    previous: "이전",
    reschedule: "일정 변경",
    reschedule_constraint: "일정 변경 요청은 최소 {hours} 시간 전에 제출해야 합니다",
    reschedule_lesson_title: "수업 일정 변경",
    reschedule_note: "변경 메모",
    reschedule_requests: "일정 변경 요청",
    save: "저장",
    send_request: "요청 보내기",
    students: "학생",
    subtitle: "여기에서 모든 수업과 가능한 시간을 확인하고 관리할 수 있습니다.",
    suggest_alternative_title: "대체 시간 제안",
    teachers: "교사",
    title: "내 일정",
    to: "부터",
    today: "오늘",
    view_lesson: "수업 보기",
    week: "주",
    your_requests: "내 요청"
  },
  my_items: {
    change_pet_button: "펫 변경",
    confirm_button: "확인",
    feed_button: "먹이 주기",
    go_to_shop_button: "상점으로 가기",
    no_content: {
      accessories: {
        subtitle: "아직 아무것도 구매하지 않았어요.",
        title: "사용 가능한 액세서리가 없어요"
      },
      food: {
        subtitle: "아직 아무것도 구매하지 않았어요.",
        title: "사용 가능한 먹이가 없어요"
      },
      pets: {
        subtitle: "상점에 가서 펫을 구매하세요.",
        title: "사용 가능한 펫이 없어요"
      }
    },
    pet_reactions: {
      accessory: [
        "완전 나한테 딱이야!",
        "이거 입으니까 너무 잘 어울려!",
        "내 새로운 스타일을 찾은 것 같아!",
        "이건 나한테 너무 잘 어울려!",
        "이 액세서리 완전 찰떡이야!",
        "이렇게 잘 어울리다니 믿기 힘들어!",
        "이 스타일은 내 거야!",
        "완전 내 스타일이야!",
        "나 좀 봐, 너무 멋져!",
        "이거 착용하니까 너무 스타일리시해!",
        "와우, 나 정말 멋져 보여!",
        "이건 나를 위해 만들어진 거야!",
        "지금 엄청 고급스러운 기분이야!",
        "이게 진짜 패션이지!",
        "완전 멋있어 보여!",
        "너무 귀여워서 심쿵!",
        "이게 내 새로운 최애일 것 같아!",
        "스타가 된 기분이야!",
        "이건 내가 태어나서 쓰라고 있는 거야!",
        "꾸미는 건 정말 재미있어!"
      ],
      after_eating: [
        "음~ {food_name} 너무 맛있다! 😋",
        "나 {food_name} 정말 좋아해! ❤️",
        "{food_name} 고마워! 😊",
        "{food_name}! 진짜 맛있어! 😋"
      ],
      full: [
        "배불러! 😋",
        "이제 배가 불러요! 😌",
        "충분히 먹었어요, 고마워요! 🙏"
      ],
      hungry: [
        "너무 배고파요! 😢",
        "먹을 것 좀 주세요! 🍽️",
        "배가 꼬르륵거려요! 🥺",
        "먹이 좀 주세요! 🙏"
      ]
    },
    subtitle: "내 소지품이에요!",
    tabs: {
      accessories: "액세서리",
      food: "먹이",
      pets: "펫"
    },
    take_off_button: "벗기기",
    title: "내 아이템"
  },
  notifications: {
    empty: "알림 없음",
    messages: {
      ASSIGNMENT_CREATED: "{name}가 과제 {description}을 생성했습니다",
      ASSIGNMENT_GRADED: "{name}가 과제 {description}을 채점했습니다",
      ASSIGNMENT_SUBMITTED: "{name}가 {description}에 대한 과제를 제출했습니다",
      ENROLLMENT_STUDENT: "{name}가 {description}에 등록했습니다",
      ENROLLMENT_STUDENT_AGENCY: "{name}가 {description}에 등록했습니다",
      ENROLLMENT_TEACHER_AGENCY: "{name}가 귀하의 기관에 등록했습니다",
      LESSON_CANCELLED: "{name}가 {description}에 대한 수업을 취소했습니다",
      LESSON_CANCEL_REQUESTED: "{name}가 {description}에 대한 수업을 취소 요청했습니다",
      LESSON_RESCHEDULED: "{name}가 {description}에 대한 수업을 재조정했습니다",
      LESSON_RESCHEDULE_REQUESTED: "{name}가 {description}에 대한 수업을 재조정 요청했습니다",
      LESSON_REVIEWED: "{name}가 귀하의 {description}을 평가했습니다",
      STUDENT_REVIEWED: "{name}가 수업 {description}에 대한 피드백을 주었습니다"
    },
    title: "알림"
  },
  onboarding_zoom: {
    student: {
      welcome_title: 'Funclass에 오신 것을 환영합니다 ',
      welcome_subtitle: "2단계만에 빠르게 수업을 준비해보세요!",
      title_step_1: "Zoom을 연결하여 학습을 시작하세요",
      description_step_1_1: "Funclass는 라이브 수업에 Zoom을 사용합니다. 이제 링크 없이 Funclass에서 바로 참여할 수 있어요!",
      description_step_1_2: "Zoom 수업을 들으며 보상을 받고 내 아바타를 키워보세요!",
      connect_button: "Zoom 연결하기",
      skip_button: "지금은 건너뛰기",
      watch_tutorial: "튜토리얼 영상 보기",
      tutorial_subtitle: "단 1분 만에 Funclass 사용법을 배워보세요",
      finish_onboarding_button: "학습 시작하기",
      handbook_button: "핸드북 읽기"
    },
    teacher: {
    },
  },
  onboarding: {
    course: {
      browser_notice: [
        {
          acknowledgement_text: "나는 읽었고 이해했습니다.",
          body: [
            "",
            "최적의 성능과 호환성을 위해 아래 지원되는 브라우저 중 하나를 사용해 주세요 🚀",
            "🔹 데스크탑/노트북: Chrome, Firefox 또는 Edge (최신 버전)",
            "🔹 모바일 (iOS 12.2 이상): Safari",
            "🔹 모바일 (Android 10.0 이상): Chrome"
          ],
          header: [
            "⚠️ 읽어주세요: 지원되는 브라우저"
          ]
        }
      ],
      egg_unhatched: "당신의 펫은 아직 부화하지 않았습니다. 수업에서 XP를 획득하여 __레벨 {level}__로 업그레이드하여 알을 부화시키세요!",
      teacher: [
        {
          body: [
            "Funclass에서는 교사가 학생들의 학습 노력과 진행 상황에 대해 XP(경험치)를 보상할 수 있습니다. 마치 게임처럼요!"
          ],
          button_text: "다음",
          header: [],
          title: "Funclass에 오신 것을 환영합니다 🎉!"
        },
        {
          body: [
            "그들의 학습 과정을 보여주세요",
            "마법의 펫 레벨을 올리세요",
            "더 많은 놀라움을 열어보세요!"
          ],
          button_text: "다음",
          header: [
            "학생들이 실제 노력과 진행 상황을 보이지 않는 한 XP를 남용하지 마세요.",
            "XP를 통해 학생들은..."
          ]
        },
        {
          body: [
            "적극적인 수업 참여",
            "수업 내 퀴즈",
            "과제 완료",
            "수업 준비 잘하기",
            "그리고 기타 긍정적인 학습 행동..."
          ],
          button_text: "다음",
          header: [],
          title: "학생들에게 보상을 줄 수 있는 방법은..."
        },
        "",
        {
          body: [
            "Funclass 핸드북을 읽고 팁과 모범 사례를 확인하세요."
          ],
          header: []
        }
      ]
    },
    navigation: {
      finish: "완료",
      next: "다음",
      skip_now: "지금 건너뛰기"
    }
  },
  profile: {
    avatar_actions: {
      my_items: "내 아이템",
      pet_guide: "펫 가이드",
      shop: "상점"
    },
    avatar_messages: {
      first_xp: "와우! 지난 수업에서 {lastXP} XP를 얻었어요. 나를 부화시키려면 {xpToNextLevel} XP가 더 필요해요. 나는 어떻게 생겼을지 궁금해요 🐣",
      hungry: "배고파요 🥺. 수업에서 음식을 얻어 나에게 먹이를 주세요.",
      level_up: "와우! 지난 수업에서 {lastXP} XP를 얻었어요. 다음 레벨까지 {xpToNextLevel} XP가 더 필요해요. 계속 힘내세요!",
      pet_gone_generic: "안타깝게도, 당신의 펫은 사라졌어요... 💔",
      pet_gone_named: "안타깝게도, {petName}은 사라졌어요... 💔",
      pet_revive_hint_generic: "펫을 부활시키려면 최소 100 HP가 필요해요.",
      pet_revive_hint_named: "{petName}을 부활시키려면 최소 100 HP가 필요해요.",
      pet_revived: "저를 다시 찾기 위해 열심히 노력해 주셔서 감사해요! 너무 보고 싶어요! 이제 저에게 먹이를 줄 수 있어요 🙂",
      welcome_back: "안녕하세요 {name}, 다시 만나서 반가워요!👋 오늘 함께 새로운 걸 배우러 갈 준비가 되었어요! 📚✨",
      welcome_new: "안녕하세요 {name} 👋, 만나서 반가워요! 저는 당신의 학습 동반자 {petName}이에요. 수업에서 XP를 얻어 저를 부화시켜요! 🐣"
    },
    coin_modal: {
      earned_coins: "와우! {rewardAmount} FunCoins을 얻었어요!",
      shop_button: "상점으로 가기"
    },
    feedback_modal: {
      description: "아래에 수업 경험을 평가해주세요",
      label: "왜 이 평가를 주셨나요?",
      lesson_not_ended: "수업이 아직 끝나지 않았나요?",
      no_rating: "평가 없음",
      rating_format: "{rating}/5 별",
      rules: {
        max: "피드백은 300자 이하로 작성해야 합니다.",
        min: "피드백은 10자 이상이어야 합니다.",
        required: "피드백은 필수입니다."
      },
      submit_button: "피드백 제출",
      title: "수업 피드백"
    },
    level_up_modal: {
      submit_button: "제출"
    },
    pet_letter: {
      letter_title_generic: "당신의 펫의 편지",
      letter_title_named: "{petName}의 편지",
      open_button: "열기",
      paragraph_1: "저를 만나고 함께 학습할 수 있어서 정말 좋았어요. 저와 함께 배운 시간이 매우 즐거웠어요. 하지만 최근에 조금 무시당하는 느낌이 들어요. 💔",
      paragraph_2: "그래서 좀 더 배려 있는 환경을 찾아 잠시 떠나기로 했어요. 상점에서 물약을 사서 나를 되찾으려면 동전 200개를 모아!",
      paragraph_3: "곧 다시 만나길 기대할게요!",
      received_title_generic: "당신은 펫으로부터 편지를 받았어요",
      received_title_named: "당신은 {petName}의 편지를 받았어요",
      signature: "당신의, \n{petName}"
    },
    revive_pet_modal: {
      revive_button: "부활",
      revive_message_generic: "100 HP를 모았어요 🎉\n이제 펫을 부활시킬 수 있어요.",
      revive_message_named: "100 HP를 모았어요 🎉\n이제 {petName}을 부활시킬 수 있어요.",
      title: "보상"
    },
    title: "내 홈",
    your_classes: "내 수업"
  },
  quiz: {
    create: "퀴즈 만들기",
    create_description: "퀴즈 설명",
    create_name: "퀴즈 이름",
    delete: "삭제",
    delete_confirmation: "삭제 확인",
    delete_message: "정말로 이 퀴즈를 삭제하시겠어요?",
    edit: {
      add_alt_answer: "대체 답변 추가",
      add_answer: "답변 추가",
      add_question: "질문 추가",
      delete_message: "정말로 이 질문을 삭제하시겠어요?",
      delete_question: "질문 삭제",
      save_question: "질문 저장",
      title: "퀴즈 편집"
    },
    edit_questions: "질문 편집",
    folder: {
      create: "폴더 만들기",
      create_name: "폴더 이름",
      delete: "폴더 삭제",
      delete_confirmation: "삭제 확인",
      delete_message: "정말로 이 폴더를 삭제하시겠어요? 이 폴더 안의 모든 퀴즈가 삭제됩니다.",
      edit: "폴더 편집",
      name_limit: "문자는 50자를 초과할 수 없습니다.",
      name_not_empty: "폴더 이름은 비워둘 수 없습니다.",
      save: "폴더 저장",
      title: "퀴즈 대시보드"
    },
    name_limit: "문자는 50자를 초과할 수 없습니다.",
    name_not_empty: "퀴즈 이름은 비워둘 수 없습니다.",
    save: "퀴즈 저장",
    title: "퀴즈 대시보드"
  },
  recording: {
    delete_confirmation: "정말로 이 녹음을 삭제하시겠어요?"
  },
  scheduling: {
    edit: {
      error: "이벤트 업데이트 중 오류가 발생했습니다.",
      options: {
        current: "이 수업",
        future: "이 수업 및 이후 수업",
        title_delete: "삭제할 이벤트 선택",
        title_edit: "변경 사항을 적용할 이벤트 선택"
      },
      title: "예정된 수업 편집"
    },
    end_date: "종료 날짜",
    lesson_time: "수업 시간",
    lesson_time_info: "로컬 시간을 선택하세요. 우리는 자동으로 학생의 시간대에 맞게 시간을 조정합니다.",
    recurrence: {
      biweekly: "매 2주마다",
      custom: "맞춤 설정",
      daily: "매일",
      label: "반복",
      none: "없음",
      occurs_on: "발생 날짜",
      repeat_every: "반복 주기",
      time_unit_day: "일 | 일들",
      time_unit_week: "주 | 주들",
      weekly: "주간"
    },
    reminder: {
      hours_before: "{n} 시간 전 | {n} 시간 전",
      label: "학생 알림"
    },
    start_date: "시작 날짜"
  },
  shop: {
    buy_now_button: "지금 구매",
    buy_pet_button: "펫 구매",
    cancel_button: "취소",
    confirm_button: "확인",
    level_constraint: "{level} 레벨에 도달하여 이 아이템을 잠금 해제하세요",
    no_content: {
      accessories: {
        subtitle: "나중에 더 많은 아이템을 확인하세요.",
        title: "사용 가능한 액세서리가 없습니다"
      },
      food: {
        subtitle: "나중에 더 많은 아이템을 확인하세요.",
        title: "사용 가능한 음식이 없습니다"
      },
      pets: {
        subtitle: "나중에 더 많은 펫을 확인하세요.",
        title: "사용 가능한 펫이 없습니다"
      },
      wallpapers: {
        subtitle: "나중에 더 많은 배경화면을 확인하세요.",
        title: "사용 가능한 배경화면이 없습니다"
      }
    },
    notify: {
      pet_name_required: "펫 이름을 입력해주세요"
    },
    pet_name: "펫 이름",
    pet_name_prompt: "펫에게 이름을 지어주세요!",
    subtitle: "여기에서 펫을 위한 아이템을 구매할 수 있습니다!",
    title: "상점"
  },
  sidebar: {
    actions: {
      account_settings: "계정 설정",
      logout: "로그아웃"
    },
    activities: {
      homework: "숙제",
      quiz: "퀴즈",
      short_title: "활동들",
      title: "활동들"
    },
    agency_name_placeholder: "당신의 기관",
    courses: {
      calendar: "일정",
      courses: "강좌",
      history: "기록",
      short_title: "강좌들",
      title: "강좌들"
    },
    general: {
      home: "홈",
      short_title: "일반",
      students: "학생들",
      teachers: "선생님들",
      title: "일반"
    }
  },
  understandingCheck: {
    start: "이해도 확인을 시작하려고 합니다.",
    student: "지금 기분이 어떠세요?",
    studentButtonNo1: "음🤔️",
    studentButtonNo2: "조금 혼란스러워요.",
    studentButtonYes1: "좋아요! 😄",
    studentButtonYes2: "이해했어요.",
    teacher: "학생들이 지금 어떻게 느끼고 있나요"
  },
  upload: {
    agency_logo_upload: "학교 로고를 업로드하세요",
    drag_and_drop: "또는 드래그 앤 드롭",
    photo_upload: "이미지 업로드",
    pick_file: "파일 선택",
    square_image: "정사각형 이미지가 권장됩니다.",
    upload: "업로드",
    upload_file: "파일 업로드",
    upload_file_type: "{formats} 형식만 지원됩니다."
  },
  viewClass: {
    absence: "결석",
    addMore: "학생 추가",
    addStudent: "학생 초대",
    addStudents: "학생들 추가",
    attendance: "출석",
    date: "날짜",
    download_recording: "녹화 다운로드",
    email: "이메일 주소",
    enterEmail: "학생 이메일을 입력하세요",
    feedback_button: "피드백",
    invite: "초대하기",
    lesson: "수업",
    notEmpty: "필드를 비워둘 수 없습니다",
    notValid: "유효하지 않은 이메일입니다",
    recording_button: "녹화",
    student_name: "학생 이름",
    tabs: {
      course_material: "수업 자료 슬라이드",
      lesson_history: "수업 기록",
      student_list: "학생 목록"
    },
    xps_earned: "획득한 XP"
  }
};
